export type PipelineStage =
  | 'Applied'
  | 'Screening'
  | 'Shortlisted'
  | 'Interview'
  | 'Offer'
  | 'Hired'

export type PipelineOutcome = 'Rejected' | 'Withdrawn'

export const PIPELINE: PipelineStage[] = [
  'Applied',
  'Screening',
  'Shortlisted',
  'Interview',
  'Offer',
  'Hired',
]

export const PIPELINE_OUTCOMES: PipelineOutcome[] = ['Rejected', 'Withdrawn']

export type ListingState = 'Draft' | 'Published' | 'Closed'

export interface EmployerListing {
  id: string
  title: string
  kind: 'Job' | 'Internship' | 'Graduate programme'
  location: string
  workMode: 'On site' | 'Hybrid' | 'Remote'
  compensationLabel: string
  deadlineLabel: string
  state: ListingState
  targetProgrammes: string[]
  targetLevels: string[]
  requirements: string[]
  applications: number
  views: number
}

export interface Candidate {
  id: string
  listingId: string
  displayName: string
  initials: string
  handle: string
  university: string
  programme: string
  level: string
  stage: PipelineStage | PipelineOutcome
  appliedOn: string
  /** Only the fields this candidate's career-profile visibility permits. */
  visibleFields: { label: string; value: string }[]
  withheldFields: string[]
  skills: string[]
}

export interface RecruitmentCampaign {
  id: string
  name: string
  universities: string[]
  startsOn: string
  endsOn: string
  state: 'Planning' | 'Live' | 'Complete'
  targetHires: number
  applications: number
  shortlisted: number
}

export interface EmployerEvent {
  id: string
  title: string
  university: string
  dateLabel: string
  capacity: number
  registered: number
  kind: 'Career fair' | 'Info session' | 'Assessment day' | 'Workshop'
}
